export const routes = {
	home: '/',
	start: '/start',
	calendar: '/calendar',
	login: '/login',
	signup: '/signup',
	stats: '/stats',
};

export const endpoints = {
	moods: '/moods/',
	users: '/users/',
	moodData: '/moodData/',
};

export const steps = {
	done: 'DONE',
	name: 'NAME',
	mood: 'MOOD',
};

export const months = {
	'01': 'jan',
	'02': 'feb',
	'03': 'mar',
	'04': 'apr',
	'05': 'may',
	'06': 'jun',
	'07': 'jul',
	'08': 'aug',
	'09': 'sep',
	'10': 'oct',
	'11': 'nov',
	'12': 'dec',
};

export const moodsArray = [
	'happy',
	'inlove',
	'relaxed',
	'pleased',
	'neutral',
	'sad',
	'confused',
	'angry',
];

export const randomMessages = [
	'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
	'rutrum consequat',
	'Quisque non enim urna.',
	'Vivamus vitae quam tortor',
	':(',
	':)',
	'In ac semper augue.',
	null,
];
